import { Record } from 'immutable'

export class OrgInactiveNotification extends Record({
  id: null,
  order: 0,
  image: '',
  quote: '',
  quoteAuthor: '',
  subject: '',
}) {}
